module.exports = __webpack_public_path__ + "static/media/Theme7.0b74f2de.png";